import { FC } from 'react';
import React from 'react';
import { useEffect, useState } from 'react';

import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import InputDescription from '../quiz-input-show-description/quiz-input-show-description';
import './MultipleTextBoxWithDescription.css';
// import { useQuizFormContext } from '@/features/dashboard/features/quiz/quiz-form-context';
import TextArea from 'antd/lib/input/TextArea';
import { useQuizFormContext } from '../../hooks/quiz-form-context';

const MultipleTextBoxWithDescription = ({
  title,
  name,
  size = 'large',
  Error,
  description,
  indexKey,
  allInputOnchageHandler,
  questionTooltip
}) => {
  const {
    formValues,
    contentFullErrorMsg,
    setContentFulErrorMsg,
    getInputValues,
    allFormErrorsList,
  } = useQuizFormContext();
  // Fetch data from local storage
  const tempObjVal = getInputValues(name, formValues);

  // Use local storage data or set default value (empty string)
  const initialMultipleInputVal = tempObjVal?.value || [''];

  const [multipleInputVal, setMultipleInputVal] = useState(initialMultipleInputVal);

  // Custom array comparison function
  const areArraysEqual = (arr1, arr2) => {
    return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
  };

  useEffect(() => {
    // If local storage data changes, update the state
    if (tempObjVal?.value && !areArraysEqual(tempObjVal?.value, multipleInputVal)) {
      setMultipleInputVal(tempObjVal?.value);
    }
  }, [tempObjVal]);

  //SHOWING QUESTION TITLE AND DESCRIPTION
  function ShowDescription(description) {
    return <InputDescription description={description} questionTooltip={questionTooltip} />;
  }

  function handleInputChange(e, index) {
    const { value, name } = e.target;
    // Extracting information from the input name
    const [, inputType, inputIndex] = name.split('-');
    // Ensure that the input name follows the expected format
    if (inputType && inputIndex !== undefined) {
      const updatedValues = [...multipleInputVal];

      // Check if the object for this index already exists, if not, create it
      if (!updatedValues[index]) {
        updatedValues[index] = {};
      }

      // Assign the value to the corresponding property in the object
      updatedValues[index][inputType] = value;

      // Update the state with the modified array of objects
      setMultipleInputVal(updatedValues);
    } else {
      console.error(`Invalid input name format: ${name}`);
    }
  }

  const removeField = (index) => {
    const updatedValues = [...multipleInputVal];
    updatedValues.splice(index, 1);
    setMultipleInputVal(updatedValues);
  };

  useEffect(() => {
    allInputOnchageHandler(indexKey, title, name, multipleInputVal);
  }, [multipleInputVal]);

  return (
    <div>
      <Form.List
        className="multiple-inputboc-container"
        name={`names-${indexKey}`}
        initialValue={initialMultipleInputVal}
        rules={
          [
            // {
            //   validator: async (_, names) => {
            //     if (!names || names.length < 1) {
            //       return Promise.reject(new Error('At least 1 passenger'));
            //     }
            //   },
            // },
          ]
        }
      >
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map((field, index) => {
                return (
                  <Form.Item
                    label={index === 0 ? description && ShowDescription(description) : ''}
                    required={Error ? true : false}
                    key={field.key}
                  >
                    <Form.Item
                      {...field}
                      validateTrigger={['onChange', 'onBlur']}
                      rules={
                        [
                          // {
                          //   required: true,
                          //   whitespace: true,
                          //   message: "Please input passenger's name or delete this field.",
                          // },
                        ]
                      }
                      noStyle
                    >
                      <Input
                        size={size}
                        name={`${name}-name-${index}`}
                        onChange={(e) => handleInputChange(e, index)}
                        className={fields.length > 1 ? 'multiple-input-text' : 'input-text'}
                        // defaultValue={multipleInputVal[index]}
                        defaultValue={
                          getInputValues(name, formValues)?.value
                            ? getInputValues(name, formValues)?.value[index]?.name
                            : ''
                        }
                        style={{ maxWidth: '75%' }}
                        placeholder="Name"
                      />
                      <TextArea
                        className={
                          fields.length > 1
                            ? 'multiple-input-text-description'
                            : 'input-text-description'
                        }
                        name={`${name}-description-${index}`}
                        onChange={(e) => handleInputChange(e, index)}
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        defaultValue={
                          getInputValues(name, formValues)?.value
                            ? getInputValues(name, formValues)?.value[index]?.description
                            : ''
                        }
                        placeholder="Description"
                        style={{ maxWidth: '75%' }}
                      />
                    </Form.Item>
                    {/* {allFormErrorsList[name] && <span className="error-message">{Error}</span>} */}
                    {fields.length > 1 ? (
                      <Button
                        className="multiple-input remove-button"
                        type="text"
                        onClick={() => {
                          removeField(index);
                          remove(field.name);
                        }}
                      >
                        <span>
                          <CloseOutlined />
                        </span>{' '}
                        Remove
                      </Button>
                    ) : null}
                  </Form.Item>
                );
              })}

              <Button
                type="dashed"
                className="multiple-input add-button"
                onClick={() => add()}
                icon={<PlusOutlined />}
              >
                Add item
              </Button>
            </>
          );
        }}
      </Form.List>
    </div>
  );
};

export default MultipleTextBoxWithDescription;
